




















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteAnestesistasStore from '@/components/Suporte/Store/SuporteAnestesistasStore'
import _ from 'lodash'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteAnestesistas extends Vue {
  loadAnestesista: string = ''
  loadAddAnestesistas: boolean = false

  get getSuporteAnestesistasStore() {
    return getModule(SuporteAnestesistasStore, this.$store)
  }

  get loadingAddAnestesistas() { return this.loadAddAnestesistas }
  set loadingAddAnestesistas(value: boolean) { this.loadAddAnestesistas = value }
  get loadingAnestesista() { return this.loadAnestesista }
  set loadingAnestesista(value: string) { this.loadAnestesista = value }

  get hospitalId() { return this.getSuporteAnestesistasStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteAnestesistasStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get anestesistasHeaders() {
    return [
      { text: 'Nome', value: 'anestesistaNnome', sortable: false },
      { text: 'Documento', value: 'documento', sortable: false },
      { text: 'CRM', value: 'crm', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'HisID', value: 'id', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get anestesistasHospital() { return this.getSuporteAnestesistasStore.anestesistasHospital }
  get searchAnestesistasHospital() { return this.getSuporteAnestesistasStore.searchAnestesistasHospital }
  set searchAnestesistasHospital(value: string) { this.getSuporteAnestesistasStore.setSearchAnestesistasHospital(value) }

  searchAnestesistasDebounce = _.debounce(() => this.getSuporteAnestesistasStore.getAllAnestesistasByHospitalId(), 700)

  async hospitalChange(id: any) {
    this.getSuporteAnestesistasStore.clearSearchAnestesistasHospital()
    this.getSuporteAnestesistasStore.setHospitalId(id)
    this.getSuporteAnestesistasStore.clearAnestesistasHospital()
  }

  async editarAnestesista(item: any) {
    this.loadingAnestesista = item.id
    this.loadingAnestesista = ''
  }

  async adicionarAnestesista() {
    this.getSuporteAnestesistasStore.setModal({ name: 'anestesistas', value: true })
  }

  @Watch('searchAnestesistasHospital')
  async onChangeSearchAnestesistasHospital(value: any) {
    this.searchAnestesistasDebounce()
  }

  beforeDestroy() {
    this.getSuporteAnestesistasStore.clearAnestesistas()
    this.getSuporteAnestesistasStore.clearAnestesistasHospital()
    this.getSuporteAnestesistasStore.clearHospitalId()
  }
}
